function SorterUpArrow() {
  return (
    <svg
      width="9"
      height="20"
      viewBox="0 -2 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.69216 5.63879L4.72362 1.03702C4.61003 0.905302 4.3913 0.905302 4.2765 1.03702L0.307959 5.63879C0.160528 5.81039 0.293457 6.06174 0.531521 6.06174H8.4686C8.70667 6.06174 8.83959 5.81039 8.69216 5.63879Z"
        fill="#959FAF"
      />
    </svg>
  );
}

export default SorterUpArrow;
